module.exports = __webpack_public_path__ + "files/34968cb653551c7689bc4ba6ff198b38.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/favicon/redfavicon-16x16.png
 ** module id = 809
 ** module chunks = 0
 **/